// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"65": "4319870325936428","816": "e0339304cba0c735","824": "8e7dd61da8ed0ab2",}[chunkId] + ".js"
}